<vs-dialog #dialog [config]="{ dialogContainerClass: 'max-w-[500px]' }">
  <vs-dialog-header
    [config]="{
      mode: 'simple',
      icon: 'alert-triangle',
      iconTheme: 'danger',
      title: 'Delete Dimension',
      subtitle: 'Are you sure you want to delete <strong>' + (dimension?.title || 'this dimension') + '</strong>? This action cannot be undone and will also delete all associated elements.'
    }"
  ></vs-dialog-header>

  <div class="flex gap-2">
    <button vs-button appearance="outline" class="flex-1" (click)="cancel()" [disabled]="deleting">Cancel</button>
    <button vs-button theme="danger" class="flex-1" (click)="delete()" [disabled]="deleting">
      <vs-icon slot="start" [class.animate-spin]="deleting" [name]="deleting ? 'refresh-cw-04' : 'trash-01'"></vs-icon>
      {{ deleting ? 'Deleting...' : 'Delete' }}
    </button>
  </div>
</vs-dialog>
